import { render } from "./ReadList.vue?vue&type=template&id=7f874cae&scoped=true"
import script from "./ReadList.vue?vue&type=script&lang=js"
export * from "./ReadList.vue?vue&type=script&lang=js"

import "./ReadList.vue?vue&type=style&index=0&id=7f874cae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f874cae"]])

export default __exports__